export const fontSizes = {
  /**
   * @xxs value in pixels: 10px
  */
  xxs: '0.625rem',
  /**
   * @xs value in pixels: 12px
  */
  xs: '0.75rem',
  /**
   * @sm value in pixels: 14px
  */
  sm: '0.875rem',
  /**
   * @md value in pixels: 16px
  */
  md: '1rem',
  /**
   * @lg value in pixels: 18px
  */
  lg: '1.125rem',
  /**
   * @xl value in pixels: 20px
  */
  xl: '1.25rem',
  /**
   * @2xl value in pixels: 24px
  */
  '2xl': '1.5rem',
  /**
   * @4xl value in pixels: 32px
  */
  '4xl': '2rem',
  /**
   * @5xl value in pixels: 36px
  */
  '5xl': '2.25rem',
  /**
   * @6xl value in pixels: 48px
  */
  '6xl': '3rem',
  /**
   * @7xl value in pixels: 64px
  */
  '7xl': '4rem',
  /**
   * @8xl value in pixels: 72px
  */
  '8xl': '4.5rem',
  /**
   * @9xl value in pixels: 96px
  */
  '9xl': '6rem',
} as const;

export type FontSizesKeys = keyof typeof fontSizes;
export type FontSizes = typeof fontSizes;